export default class ItemMeasureUnitModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id;
			this.name = data.name;
		}
	}

	id = 0;
	name = '';
}